export const RULE_MANAGEMENT_URLS = {
  LIST: 'rule-managements',
  CREATE: 'rule-managements/new',
  DETAILS: 'rule-managements/:ruleId',
  EDIT: 'rule-managements/edit/:ruleId',
}

export const GIFT_CONDITION_URLS = {
  LIST: 'gift-conditions',
  CREATE: 'gift-conditions/new',
  DETAILS: 'gift-conditions/:conditionId',
  EDIT: 'gift-conditions/edit/:conditionId',
}

export const PRODUCT_URLS = {
  LIST: 'products',
  // CREATE: 'products/new',
  // DETAILS: 'products/:productId',
  // EDIT: 'products/edit/:productId',
}

export const SHOP_URLS = {
  LIST: 'shops',
  CREATE: 'shops/new',
  DETAILS: 'shops/:shopId',
  EDIT: 'shops/edit/:shopId',
}

export const CUSTOMER_URLS = {
  List: '/',
}

export const ADMIN_URLS = {
  LOGIN: '/login',
}
